import { Extension } from '@tiptap/core';

export const EnterHandler = Extension.create({
  name: 'enterHandler',

  addKeyboardShortcuts() {
    return {
      'Shift-Enter': () => this.editor.commands.enter(),
      'Mod-Enter': () => this.editor.commands.enter(),
    };
  },
});
